import { envConfig } from "@configs/env";
import { STORAGE_KEY } from "@constants/index";
import { decryptText, encryptText } from "./encrypt";

const CRED_KEY = envConfig.accountId;

/**
 * Persist credential options
 * password will be encrypted
 * @param username - Phone number or username
 * @param password - Password or PIN
 */
type PersistCredentialOptions = {
  clientId?: string;
  password?: string;
  loginMethod?: "phone" | "username";
  phone?: string;
};

export const persistCredential = (options: PersistCredentialOptions) => {
  const { clientId, password, loginMethod, phone } = options;
  if (clientId) {
    localStorage.setItem(STORAGE_KEY.LOGIN_CRED_ID, clientId);
  }
  if (password) {
    // encrypt client secret
    const encryptedPassword = encryptText(password, CRED_KEY);
    localStorage.setItem(STORAGE_KEY.LOGIN_CRED_SECRET, encryptedPassword);
  }
  if (loginMethod) {
    localStorage.setItem(STORAGE_KEY.LOGIN_METHOD, loginMethod);
  }
  if (phone) {
    localStorage.setItem(STORAGE_KEY.LOGIN_PHONE, phone);
  }
};

/**
 * Get the stored credentials from localStorage
 * password will be decrypted
 * Example:
 * {
 *   username: "+639123456789",
 *   password: "1234567890",
 * }
 */
export const getStoredCredential = (): {
  clientId?: string | null;
  password?: string | null;
  phone?: string | null;
  loginMethod?: "phone" | "username";
} => {
  // fallback to login-phone for existing users
  const clientId = localStorage.getItem(STORAGE_KEY.LOGIN_CRED_ID) || localStorage.getItem("login-phone") || null;
  const encryptedPassword = localStorage.getItem(STORAGE_KEY.LOGIN_CRED_SECRET);
  const loginMethod = localStorage.getItem(STORAGE_KEY.LOGIN_METHOD) as "phone" | "username";
  const phone = localStorage.getItem(STORAGE_KEY.LOGIN_PHONE) || null;
  let password: string | undefined = undefined;

  if (encryptedPassword) {
    try {
      password = decryptText(encryptedPassword, CRED_KEY);
    } catch (error) {
      console.error("Failed to decrypt client secret:", error);
    }
  }

  return { clientId, password, loginMethod, phone };
};

export const getStoredLoginMethod = () => {
  return (localStorage.getItem(STORAGE_KEY.LOGIN_METHOD) as "phone" | "username") || "username";
};

/**
 * Clear stored credentials from localStorage
 */
export const clearStoredCredentials = (): void => {
  localStorage.removeItem(STORAGE_KEY.LOGIN_CRED_ID);
  localStorage.removeItem(STORAGE_KEY.LOGIN_CRED_SECRET);
};
